<template>
  <b-container fluid>
    <PortalNavbar v-if="!isLoggedIn"></PortalNavbar>
    <div class="containern reg-process">
      <div class="body-wrapper">
        <div class="body-title">
          <h2>Create/Edit Profile 2</h2>
        </div>
        <div class="body-content">
          <b-card no-body>
            <b-tabs card v-model="tabIndex" @input="checkTab">
              <b-tab title="Signup" key="00" v-if="!isLoggedIn" active>
                <Signup @clicked="enableTabs"></Signup>
              </b-tab>
              <b-tab title="Personal Details" ref="tbUserDetail" :disabled="disabled" key="01">
                <PersonalDetails @clicked="tabIndex++" :Loantype="getScheme.LoanType"></PersonalDetails>
              </b-tab>
              <b-tab title="Address Details" :disabled="disabled" key="02">
                <AddressDetails @clicked="tabIndex++"></AddressDetails>
              </b-tab>
               <b-tab title="Family Details" v-if="getScheme.LoanType == 1 || getScheme.LoanType == 3 && !disabled" :disabled="disabled" key="03">
                <family @clicked="tabIndex++"></family>
              </b-tab>
              <b-tab title="Bank Account" v-if="getScheme.LoanType == 1 || getScheme.LoanType == 3 && !disabled" :disabled="disabled" key="04">
                <BankAccount @clicked="tabIndex++"></BankAccount>
              </b-tab>

              <b-tab title="Group Bank Account" v-if="getScheme.LoanType == 2 && !disabled" :disabled="disabled" key="04">
                <BankAccount @clicked="tabIndex++"></BankAccount>
              </b-tab>
              <b-tab
                title="Lending Loan Details"
                v-if="getScheme.LoanType == 1 || getScheme.LoanType == 2"
                key="05"
              >
                <LendingLoanDetails @clicked="tabIndex++"></LendingLoanDetails>
              </b-tab>
              <b-tab
                title="Lending Loan Details Eductaion"
                v-if="getScheme.LoanType == 3 "
                key="05"
              >
                <LendingLoanDetails2 @clicked="tabIndex++"></LendingLoanDetails2>
              </b-tab>
              <!--<b-tab title="Loan Bank Details" v-if="getScheme.LoanType == 1 && !disabled" key="04">
                <BankDetails @clicked="tabIndex++"></BankDetails>
              </b-tab>-->
              <b-tab title="Group Details" v-if="getScheme.LoanType == 2 && !disabled" key="06">
                <GroupDetails @clicked="tabIndex++"></GroupDetails>
              </b-tab>
              <b-tab title="Directors / Shareholders" v-if="getScheme.LoanType == 2 && !disabled" key="07">
                <Directors @clicked="tabIndex++"></Directors>
              </b-tab>
              <!-- <b-tab title="Shareholders" v-if="getScheme.LoanType == 2 && !disabled" key="08">
                <Shareholders @clicked="tabIndex++"></Shareholders>
              </b-tab> -->
              <b-tab title="Upload Documents" v-if="getScheme.LoanType==1 || getScheme.LoanType == 3 && !disabled" key="09">
                <FormUploads @clicked="tabIndex++"></FormUploads>
              </b-tab>
              <b-tab title="Upload Documents" v-if="getScheme.LoanType == 2  && !disabled" key="10">
                <FormUploadGpLoan @clicked="tabIndex++"></FormUploadGpLoan>
              </b-tab>
              <b-tab title="Declaration" :disabled="disabled" key="11">
                <Declaration @clicked="tabIndex++"></Declaration>
              </b-tab>
              <b-tab title="Summary" v-if="getScheme.LoanType==1 || getScheme.LoanType==3  && !disabled" key="12">
                <Summary ref="summary"></Summary>
              </b-tab>
              <b-tab title="Summary" v-if="getScheme.LoanType == 2 && !disabled" key="13">
                <SummaryGroup ref="summary"></SummaryGroup>
              </b-tab>
            </b-tabs>
          </b-card>
        </div>
      </div>
    </div>
  </b-container>
</template>

<script>
import Signup from "@/components/RegistrationLoan/Signup";
import AddressDetails from "@/components/RegistrationLoan/AddressDetails";
// import PersonalDetails from "@/components/RegistrationMathadi/PersonalDetails";
import LendingLoanDetails from "@/components/RegistrationLoan/LendingLoan";
//education
import LendingLoanDetails2 from "@/components/RegistrationLoan/LendingLoanEducation.vue";
import BankDetails from "@/components/RegistrationLoan/BankDetailsForm";
import Declaration from "@/components/RegistrationLoan/Declaration";
//import Experience from "@/components/RegistrationMathadi/Experience";
import PersonalDetails from "@/components/RegistrationLoan/PersonalDetails";
import FormUploads from "@/components/RegistrationLoan/FormUploads";
import Summary from "@/components/RegistrationLoan/Summary";
import PortalNavbar from "@/components/PortalNavbar";
import GroupDetails from "@/components/RegistrationLoan/GroupDetails";
import Directors from "@/components/RegistrationLoan/Directors";
import Shareholders from "@/components/RegistrationLoan/Shareholders";
import FormUploadGpLoan from "@/components/RegistrationLoan/FormUploadGpLoan";
import SummaryGroup from "@/components/RegistrationLoan/SummaryGroup";
import family from "@/components/RegistrationLoan/Family";

import BankAccount from "@/components/RegistrationLoan/UserBankAccounts";
export default {
  components: {
    Signup,
    AddressDetails,
    PersonalDetails,
    LendingLoanDetails, 
    LendingLoanDetails2,
    FormUploads,
    BankDetails,
    Declaration,
    GroupDetails,
    Directors,
    Shareholders,
    PortalNavbar,
    FormUploadGpLoan,
    Summary,
    BankAccount,
    SummaryGroup,
    family
  },
  computed: {
    isLoggedIn() {
      if (this.$store.getters.isLoggedIn) {
        this.disabled = false;
        // alert(this.disabled);
      }
      return this.$store.getters.isLoggedIn;
    },
    getScheme() {
      let x = this.$store.getters.getScheme;
      //console.log (x);
      return x;
    }
  },
  data() {
    return {
      tabIndex: 0,
      disabled: true
    };
  },
  methods: {
    checkTab(n) {
      if (n < 10) {
        this.$refs.summary.CheckStatus();
      }
    },
    enableTabs() {
      this.disabled = false;
      this.tabIndex = 1;
      this.$refs.tbUserDetail.loadSignupUser();
    }
  }
};
</script>

<style scoped>
.body-wrapper {
  margin-top: 20px;
  padding-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  border: solid thin #ccc;
  box-shadow: none;
  -webkit-box-shadow: none;
  margin-bottom: 30px;
  margin-top: 30px;
}

.body-title {
  border-bottom: solid 1px #d3d3d3;
  background: #fff;
  padding: 15px 25px;
}

.body-title h2 {
  color: #000;
  font-weight: bold;
  font-size: 19px;
}

.body-content {
  padding: 25px 10px;
}
.nav > li > a {
  height: auto !important;
}

/* UI akshay 03-09-2019 */

.card {
  border: none;
}

.nav-tabs .nav-item {
  margin-right: 5px;
  margin-left: 5px;
}

@media (max-width: 419px) {
  .reg-process .body-content {
    padding: 5px 0;
  }

  .reg-process .body-title h2 {
    font-size: 17px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RegistrationLoan/LoginEditProfile.vue